
<template>
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="80"
      height="80"
      rx="40"
      fill="#EDFAF0"
    />
    <g filter="url(#filter0_d_801_195059)">
      <rect
        x="17"
        y="17"
        width="46"
        height="46"
        rx="23"
        fill="#49C966"
      />
      <path
        d="M50.2427 34.8467L36.9748 48.1144L29.5977 40.7373"
        stroke="#EDFAF0"
        stroke-width="2.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_801_195059"
        x="13"
        y="15"
        width="54"
        height="54"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.286275 0 0 0 0 0.788235 0 0 0 0 0.4 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_801_195059"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_801_195059"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>